<template>
  <div id="help-bubble-wrapper">
    <div id="help-bubble-inner">
      <img src="../assets/info.svg" alt="info-icon" style="position: absolute; margin-left: 145px; margin-top: -2px;">
      <div id="help-bubble-title">Need help?</div>
      <div><a id="email-link" :href="getHelpEmailAddress()"><span id="help-email">Email us</span></a> or call us at<br>
      615-266-5210 (Nashville)<br>
      901-270-8372 (Memphis)<br>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralMixin from '../mixins/general.js'

export default {
  name: 'HelpBox',
  mixins: [GeneralMixin],
  data() {
    return {
    }
  }
}
</script>

<style scoped>

</style>

<style>
  #help-bubble-wrapper {
    font-family: ProximaNovaRegular;
    color: #1f3561;
    width: 186px;
    height: 88px;
    background-color: #ffffff;
    margin-left: auto;
    margin-right: 30px;
    margin-top: 24px;
    font-size: 16px;
    border-radius: 6px;
    border: solid 2px #1f3561;
    z-index: 2;
    position: absolute;
    right: 0;
  }
  #help-bubble-title {
    font-family: ProximaNovaSemiBold;
  }
  #help-email {
    text-decoration: underline;
  }
  #help-bubble-inner {
    padding-left: 10px;
    padding-top: 10px;
    line-height: 1.2;
  }
  #email-link {
    color: #1f3561;
  }
  /* start of phone styles */
  @media screen and (max-width: 679px) {
    #help-bubble-wrapper {
      display: none;
    }
  }
</style>
